import { attributes, status, PASSENGER_ATTRIBUTE, STATUS_ATTRIBUTE } from 'constants/seating';
import config from 'utils/config';

const getParentSeat = (element) => {
  if (!element) {
    return null;
  }

  if (/area:selectable:seat:/.test(element.id)) {
    return element;
  }

  return getParentSeat(element.parentElement);
};

export const selectPassengerSeat = (seatMapSvg, passengerId) => {
  const passengerSeat = seatMapSvg.querySelector(`[${PASSENGER_ATTRIBUTE}="${passengerId}"]`);

  if (passengerSeat) {
    passengerSeat.setAttribute(STATUS_ATTRIBUTE, status.SELECTED);
  }
};

export const resetSeatMap = (seatMapSvg) => {
  attributes.forEach((attribute) => {
    seatMapSvg.querySelectorAll(`[${attribute}]`).forEach((seatElement) => {
      seatElement.removeAttribute(attribute);
    });
  });
};

export const getSeatMapUrl = (templateName) =>
  `${config('PROXY_URL') || ''}/seat-map/?template=${encodeURIComponent(templateName)}&x-api-key=${config('API_GATEWAY_API_KEY')}`;

export const getSeatElement = (seatMapSvg, seatNumber) => seatMapSvg.querySelector(`#area\\:selectable\\:seat\\:${seatNumber}`);

export const onSeatClick = (seatMapSvg, callback) => {
  const onClick = (e) => {
    const seat = getParentSeat(e.target);

    if (seat) {
      callback(seat);
    }
  };

  seatMapSvg.addEventListener('click', onClick, false);

  return onClick;
};
